export default __webpack_public_path__ + "static/media/logo.1a8516e6.png";